<template>
  <div class="main">
    <report-top> </report-top>
   <selectTool ref="selectTool">
      <template slot="text">线路规则列表</template>
      <template slot="btn"
        ><Button @click="getList" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action"
        ><Button size="small" @click="dropDown(row)"> 绑定 </Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增线路规划' : '编辑线路规划'"
      footer-hide
      fullscreen
      @on-cancel="cliclCancelBtn"
    >
      <div style="width: 100%; height: 100%; position: relative">
        <duobianxing ref="duobianxing" @dis='item.length=$event' v-if="openForm"></duobianxing>
        <div id="sderwwetcsd">
          <Form
            ref="item"
            :model="item"
            :rules="ruleValidate"
            :label-width="80"
          >
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="名称" prop="name">
                  <Input v-model="item.name" placeholder="请输入"></Input>
                </FormItem>
              </Col>
              
              <Col span="24">
                <FormItem label="容许时长" prop="duration">
                  <Select v-model="item.duration">
                    <Option
                      v-for="(x, index) in $t('times1')"
                      :value="x.id"
                      :key="index"
                      >{{ x.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="容许距离" prop="distance">
                  <Select v-model="item.distance">
                    <Option
                      v-for="(x, index) in $t('meters')"
                      :value="x.id"
                      :key="index"
                      >{{ x.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="线路长度" prop="length">
                  <Input v-model="item.length" readonly placeholder="请输入"></Input>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="周期设置">
                  <Button type="text" @click="openZhouqi">点击设置</Button>
                </FormItem>
              </Col>
            </Row>
            <Row type="flex" justify="end">
              <Col span="24">
                <Button type="primary" long @click="addUpdate('item')"
                  >提交表单</Button
                >
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </Modal>
    <blind ref="blind" v-model="deviceList" @blind="blind"></blind>
    <Modal
      v-model="zhouqiModel"
      title="触发周期设置"
      :mask-closable="false"
      footer-hide
      width="600"
      height="400"
    >
      <zhouqi ref="zhouqi" @zhouqi="reZhouwi"></zhouqi>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import duobianxing from "../map/xianlu.vue";
import zhouqi from "./zhouqi.vue";
export default {
  components: { duobianxing, zhouqi },
  data() {
    return {
      openForm: false,
      zhouqiModel: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "名称",
          key: "name",
        },
        {
          title: "容许时长/分钟",
          key: "duration",
          render: (h, data) => {
            return h("div", data.row.duration / 60);
          },
        },
        {
          title: "容许距离/米",
          key: "distance",
        },
        {
          title: "线路长度/米",
          key: "length",
        },
        {
          title: "创建者账号",
          key: "createAccount",
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        coordList: [
          {
            x: 0,
            y: 0,
          },
        ],
        cs: 2,
        enabled: true,
        name: "",
        distance: 5,
        duration: 60,
        length:0,
        remark: "",
        timeList: [],
        weekList: [],
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      deviceList: [],
    };
  },
  methods: {
    reZhouwi(v) {
      this.formItem = v;
      console.log(v);
      this.item.timeList = v.times;
      this.item.weekList = v.days;
      this.zhouqiModel = false;
    },
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/route/list",
        data: {},
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var ccc = this.$refs.duobianxing.getPoints();
      this.item.coordList = ccc;
      console.log(this.item);
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.rule + "/route/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.rule + "/route/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.rule + "/route/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.getItem(row, 1);
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    getItem(row, type) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/route/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (type == 1) {
            var data = res.data.data.coordList;
            this.$refs.duobianxing.reData(data);
          } else {
            var d = res.data.data.deviceList;
            this.deviceList = [];
            for (let i = 0; i < d.length; i++) {
              var obj = {
                id: d[i].deviceId,
                name: d[i].bindAttr,
                key: d[i].deviceId,
                useType: d[i].useType,
              };
              this.deviceList.push(obj);
            }
            this.$refs.blind.open(row);
          }
        }
      });
    },
    dropDown(row) {
      this.getItem(row);
      this.blindId = row.id;
    },
    blind(data) {
      this.utils.loading(this, "处理中");
      var deviceIdList = [];
      for (let i = 0; i < data.length; i++) {
        deviceIdList.push(data[i].id);
      }
      axios({
        method: "post",
        url: axios.rule + "/route/bind",
        data: { deviceIdList: deviceIdList, id: this.blindId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
      });
    },
    openZhouqi() {
      this.zhouqiModel = true;
      var ddd = {
        days: this.item.weekList,
        times: this.item.timeList,
      };
      this.$refs.zhouqi.reData(ddd);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
#sderwwetcsd {
  position: absolute;
  width: 240px;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/rule/ruleLine.vue